module.exports = __webpack_public_path__ + "img/logotop.63ad4bab.png";